import mainCaller from './mainCaller';

// 지점별 테이블 컬럼 설정(범용). tableKey 로 화면을 구분한다. 예: 'member-list'
export const getTableColumns = async (branchId, tableKey, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/table-columns/${tableKey}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 전량 교체 저장. columns = [{ key, visible, pinned }] (배열 순서 = 컬럼 순서)
export const saveTableColumns = async (branchId, tableKey, columns, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/table-columns/${tableKey}`, 'PUT', { columns }, {
    Authorization: `Bearer ${token}`,
  });
};

// 초기화 = 저장분 삭제. 이후 조회는 빈 배열(화면 기본값)
export const resetTableColumns = async (branchId, tableKey, token) => {
  return await mainCaller(`admin/api/v2/branches/${branchId}/table-columns/${tableKey}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};
